// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__uOhT6","tableText":"Table_tableText__Jg7br"};